<template>
<div class="mt-3 py-5">
	<b-container class="px-3 p-md-0">
		<b-row>
			<b-col cols="12" md="8" class="m-auto px-3">

        <div class="container">

					<div class="row justify-content-center pt-2 pb-5">

              <nav class="pankuzu w-100">
                <ul class="my-4">
                  <li><img class="" src="/static/img/icon/pankuzu.png" style="height: 17px;padding-bottom: 3px;"><a @click="jump(0)">  ピアチュウ TOP</a></li>
                  <li>  ピアチュウとは</li>
                </ul>
              </nav>

              <div class="card">
                <div class="card-header text-center">日本初！ ピアチュウとは、全国の中古ピアノ、販売業者を比較して申し込みできるサイトです</div>
                <div class="card-body">
                  <p>　ピアチュウは、日本初となる、全国の中古ピアノやピアノ販売事業者を、料金や評価から比較して、申し込みをすることができるサイトです。格安や掘り出し物のアップライトピアノ、或いは有名ブランドのグランドピアノを探している方などが、自分の条件と好みに合うピアノを納得いくまで探せます。</p>
                  <p>　”古いは価値がある”をモットーに、中古ピアノの本当の価値をぜひ知っていただきたいと思っています。あなたは、昭和のある時代に作られたヤマハ、カワイのピアノの音色と作りの良さは、最近作られた新しいピアノの質を超えることがあるのをご存じですか？あるいは有名メーカーではないコスパ重視の中古ピアノの選び方やその良さの引き出し方を、ご存じでしょうか？もしご存じでないなら、このピアチュウといっしょにそれを学びながら、あなたやご家族にいちばんふさわしいピアノをぜひ選んでいただきたいと思っています。</p>
                  <p>
                    <strong>使い方</strong>
                  </p>
                  <h2>◇ステップ1</h2>
                  <p>
                    <strong>ピアノまたは販売事業者を探す</strong>
                  </p>
                  <p>サイト内の検索から、中古ピアノや販売事業者を検索します。気になる中古ピアノや事業者があれば、お気に入り登録をします。</p>
                  <h2>◇ステップ2</h2>
                  <p>
                    <strong>試弾申し込み</strong>
                  </p>
                  <p>気に入ったピアノがあった時は、購入を決める前に、試弾をしてみることを強くお勧めします。”アナログピアノは家電製品や電子ピアノとは違う”という認識が、とても大切です。同じメーカーで同じ型のピアノでも、技術者がどのように手を加えたかたによって、音がガラッと変わることもあります。ですから、実際にその場で弾いてみると、弾き心地や音色などいろいろなことが体を通してよくわかります。また販売事業者や整備担当者からピアノの状態や整備などについてさらに詳しく情報を聞き出すことができます。そうやって販売事業者と話をすることで、ピアノを良くすることへの熱意といったニュアンスまでも伝わってきます。</p>
                  <h2>◇ステップ3</h2>
                  <p>
                    <strong>購入申し込み</strong>
                  </p>
                  <p>サイト上で十分比較検討したり、試弾によっていくつかの候補を選んだ後は、1つに絞り込みます。それで納得できると思えば、サイトから購入申し込みをします。</p>
                  <h2>◇ステップ4</h2>
                  <p>
                    <strong>ピアノ生活スタート！</strong>
                  </p>
                  <p>購入申し込みが済んだら、ピアノ販売業者とサイト内でメッセージのやり取りをしたり、電話を使って、搬入までの段取りや打合せをします。代金の支払いが済み、無事搬入が終わったら、いよいよワクワクするピアノ生活の始まりです！それを販売した業者への評価（口コミ）をお願いします。（それとは別にピアノへの評価もお願いしています）</p>
                  <br>
                  <h2>中古ピアノや業者を比較検討して申し込める唯一のウェブ・サービス</h2>
                  <p>ピアチュウでは、全国にある優良なピアノ販売事業者や中古ピアノを地域や価格で検索し、実績や販売事業者の評価などを読んで検討した上で、購入申し込みができます。
                    <br>　またピアチュウでは、中古ピアノの価値の再発見をお手伝いします。”古いは価値がある”をいっしょうけんめい伝えたいのです。それは例えば以下のようなものです
                  </p>
                  <ul>
                    <li>中古ピアノは、ピアノ調律師や修理技術者が行う整備、その中でも特に整音（弦をたたくハンマー成形）によって、格段に音が良くなり、全体のクオリティが上ることがしばしばある。</li>
                    <li>昭和のある時代に作られたヤマハ、カワイのピアノの音色と作りの良さは、最近作られた新しいピアノの質を凌駕している</li>
                    <li>100年使えなくても、30年使えれば十分という考え方にすれば、コスパ重視で無名ブランドの中古ピアノも十分視野に入ってくる</li>
                  </ul>
                  <p>このように、アナログピアノのことをもっともっと知ることで、あなたにとって本当にふさわしいピアノを見つけることができるようになります。このピアチュウを、単に中古ピアノ選びのための在庫表や販売事業者の一覧としてだけでなく、ピアノを知るための情報源、学びの場としても活用いただきたいのです。
                    <br>
                    <br>
                  </p>
                </div>
              </div>

					</div>

        </div>

			</b-col>
		</b-row>
	</b-container>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'AboutPiachu',
  data() {
    return {
    }
  },
  methods: {
    jump(number) {
      if (number==0) {
        this.$router.push({path: '/'});
      }
    },
  },
	computed: {
	},
  created() {
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AboutPiachu.vue